import { useEffect, useRef, useState } from 'react';
import Image, { ImageProps } from 'next/image';
import { RiImageLine } from 'react-icons/ri';

import manifest from '../../../../public/images/precision/catalog/manifest.json';

export const EquipmentImage = ({
  src,
  alt,
  unoptimized,
  ...props
}: Omit<ImageProps, 'src'> & { src?: string | null }) => {
  const [failed, setFailed] = useState(false);
  const imageRef = useRef<HTMLImageElement>(null);
  const cached = src ? (manifest.images as Record<string, string>)[src] : undefined;
  const imageSrc =
    cached ||
    (src?.startsWith('http') ? `https://domstankov.com/_next/image?url=${encodeURIComponent(src)}&w=1080&q=75` : src);
  useEffect(() => {
    const image = imageRef.current;
    setFailed(Boolean(image?.complete && image.naturalWidth === 0));
  }, [imageSrc]);
  if (!imageSrc || failed)
    return (
      <span className="equipment-placeholder">
        <RiImageLine />
        <span>Фото уточняется</span>
      </span>
    );
  return (
    <Image
      {...props}
      ref={imageRef}
      alt={alt}
      src={imageSrc}
      unoptimized={unoptimized ?? !imageSrc.startsWith('/')}
      onError={() => setFailed(true)}
    />
  );
};
